"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var arrayValidations = {
    length: function (array) { return array.length; },
    containsAny: function (arr1, arr2) { return arr1.some(function (r) { return arr2.indexOf(r) >= 0; }); },
};
exports.default = arrayValidations;
//# sourceMappingURL=arrayValidations.js.map